export const tagOptions = [
    { tag: 'all', name: 'all' },
    { tag: 'people', name: 'portraits' },
    { tag: 'animal', name: 'pets' },
    { tag: 'place', name: 'places' },
    { tag: 'thing', name: 'things' },
    { tag: 'music', name: 'concerts' }
]
